const initialLanguageSkill = {
    order: -1,
    language: { code: null },
    listeningComprehensionLevel: null,
    readingComprehensionLevel: null,
    continuousOralExpressionLevel: null,
    writingExpressionLevel: null,
    oralInteractionLevel: null,
};

export const languageSkillsActionTypes = {
    ADD_LANGUAGE_SKILL: "ADD_LANGUAGE_SKILL",
    REMOVE_LANGUAGE_SKILL: "REMOVE_LANGUAGE_SKILL",
    CHANGE_LANGUAGE_SKILL: "CHANGE_LANGUAGE_SKILL",
    MOVE_LANGUAGE_SKILL_UP: "MOVE_LANGUAGE_SKILL_UP",
    MOVE_LANGUAGE_SKILL_DOWN: "MOVE_LANGUAGE_SKILL_DOWN",
}

export function languageSkillsReducer( languageSkills, action ) {
    let updatedLanguageSkills;
    let numberOfLanguageSkills = languageSkills.length;
    let currentOrder = action.item.order;

    switch ( action.type ) {
        case languageSkillsActionTypes.ADD_LANGUAGE_SKILL: {
            let newLanguageSkill = action.item || initialLanguageSkill;

            newLanguageSkill = {
                ...newLanguageSkill,
                order: numberOfLanguageSkills,
            }

            updatedLanguageSkills = [
                ...languageSkills,
                {
                    order: numberOfLanguageSkills++,
                    item: newLanguageSkill,
                }
            ];
            break;
        }

        case languageSkillsActionTypes.REMOVE_LANGUAGE_SKILL:
            updatedLanguageSkills = languageSkills
                .filter( languageSkill => languageSkill.order !== action.item.order )
                .sort( ( a, b ) => a.order - b.order )
                .map( ( languageSkill, index ) => {
                    languageSkill.order = index;
                    return languageSkill;
                } );
            break;

        case languageSkillsActionTypes.CHANGE_LANGUAGE_SKILL:
            updatedLanguageSkills = languageSkills
                .map( languageSkill => {
                        if ( languageSkill.order === action.item.order ) {
                            return action.item
                        } else {
                            return languageSkill
                        }
                    }
                )
            break;

        case languageSkillsActionTypes.MOVE_LANGUAGE_SKILL_UP:
            updatedLanguageSkills = languageSkills
                .map( languageSkill => {
                    if ( languageSkill.order === action.item.order ) {
                        languageSkill.order--;
                    } else if ( languageSkill.order === action.item.order - 1 ) {
                        languageSkill.order++;
                    }
                    return languageSkill
                } );
            break;

        case languageSkillsActionTypes.MOVE_LANGUAGE_SKILL_DOWN:
            updatedLanguageSkills = languageSkills
                .map( languageSkill => {
                    if ( languageSkill.order === currentOrder ) {
                        languageSkill.order++;
                    } else if ( languageSkill.order === currentOrder + 1 ) {
                        languageSkill.order--;
                    }
                    return languageSkill
                } );
            break;

        default: {
            throw new Error( `Unknown action: [${ action.type }]` );
        }
    }

    return updatedLanguageSkills.sort( ( a, b ) => a.order - b.order );
}

